<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <div class="page-title-right">
        <ol class="breadcrumb m-0">
          <ng-container *ngFor="let item of breadcrumbItems">
            <li class="breadcrumb-item" *ngIf="!item.active"><a (click)="listarPastas(item)" href="javascript: void(0);">{{ item.des_pasta_pas }}</a>
            </li>
            <li class="breadcrumb-item active" *ngIf="item.active">{{ item.des_pasta_pas }}
            </li>
          </ng-container>
        </ol>
      </div>
    </div>
  </div>
</div>
